import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { testimonials } from '../mock';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-sage-green/5 to-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest-green mb-4">
            Healing Stories
          </h2>
          <p className="text-lg text-earth max-w-2xl mx-auto">
            Real experiences from patients who found their path to wellness
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.id}
              className="group relative overflow-hidden border-none bg-white/80 backdrop-blur-md hover:bg-white hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              <CardContent className="p-8">
                {/* Rating Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-sage-green text-sage-green" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-earth leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </p>

                {/* Author Info */}
                <div className="border-t border-sage-green/20 pt-4">
                  <p className="font-serif font-bold text-forest-green text-lg">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-sage-green font-medium">
                    {testimonial.condition}
                  </p>
                </div>

                {/* Decorative Quote Mark */}
                <div className="absolute top-4 right-4 text-6xl text-sage-green/10 font-serif">
                  "
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
